import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { FadeUp, Overline } from "../components/Reveal";

const sections = [
  {
    title: "Acceptance of Terms",
    body: "By accessing Vincen, creating an account, or placing an order, you agree to these Terms of Service. If you do not agree, we kindly ask that you refrain from using the house. We may update these terms from time to time, and continued use constitutes acceptance of the revised terms.",
  },
  {
    title: "The Collections",
    body: "All pieces are released in limited quantity. We make every effort to present colours, materials, and detailing faithfully, though slight variation is natural to hand-finished garments. Availability is not guaranteed until an order is confirmed.",
  },
  {
    title: "Accounts",
    body: "You are responsible for keeping your account credentials confidential and for all activity under your account. An account is required to place an order. You agree to provide accurate information and to keep it current.",
  },
  {
    title: "Orders & Pricing",
    body: "Prices are shown in euro and may change without notice. An order is an offer to purchase; we reserve the right to decline or cancel any order, including for suspected fraud or pricing error. The present checkout is a demonstration and processes no live payment.",
  },
  {
    title: "Intellectual Property",
    body: "The Vincen name, emblem, designs, imagery, and written word are the property of the house and are protected by law. Nothing on this site grants you a right to reproduce, resell, or create derivative works without our written consent.",
  },
  {
    title: "Limitation of Liability",
    body: "Vincen is provided \u201cas is\u201d. To the fullest extent permitted by law, we are not liable for indirect or consequential loss arising from your use of the site or our pieces. Nothing in these terms limits liability that cannot be excluded under applicable law.",
  },
  {
    title: "Contact",
    body: "Questions regarding these terms may be addressed to vinceninfo@gmail.com, where a member of the house will attend to you.",
  },
];

const Terms = () => {
  return (
    <div data-testid="terms-page" className="min-h-screen pt-28 md:pt-36 pb-28">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <Link
          to="/"
          data-testid="terms-back-link"
          className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase text-zinc-500 hover:text-gold transition-colors duration-300"
        >
          <ArrowLeft size={13} /> The House
        </Link>

        <FadeUp>
          <div className="mt-10">
            <Overline>Information</Overline>
            <h1 className="mt-4 font-serif text-4xl md:text-6xl font-light text-[#F5F5F5] leading-tight">
              Terms of Service
            </h1>
            <p className="mt-6 text-xs tracking-[0.3em] uppercase text-zinc-500">
              Last updated &mdash; June 2026
            </p>
          </div>
        </FadeUp>

        <div className="mt-16 flex flex-col gap-12">
          {sections.map((s, i) => (
            <FadeUp key={s.title} delay={0.05}>
              <div data-testid={`terms-section-${i}`} className="border-t border-white/10 pt-8">
                <h2 className="font-serif text-2xl md:text-3xl font-light text-[#F5F5F5]">
                  {s.title}
                </h2>
                <p className="mt-4 text-sm md:text-base text-zinc-400 leading-relaxed">
                  {s.body}
                </p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;
